/**
 * Leftovers (PLAN §9 #7): a recipe that serves 8 cooked for a household of 4
 * makes a second meal. These helpers decide how many servings are left over
 * and where the leftovers meal goes by default. Pure — no I/O.
 */
/**
 * Whole servings the plan makes beyond `planServings`.
 *
 * Each recipe with a known yield makes `servings × scale` portions; recipes
 * without a yield are ignored. A meal is usually one main plus sides, so the
 * leftover count is driven by the recipe that makes the most portions (the
 * largest surplus), rounded down to whole servings. Never negative.
 */
export function leftoverServings(recipes, planServings) {
    let best = 0;
    for (const r of recipes) {
        if (r.servings === null || !(r.servings > 0) || !(r.scale > 0))
            continue;
        // Round first so float noise (e.g. 2.9999999) doesn't lose a serving.
        const made = Math.floor(Math.round(r.servings * r.scale * 1000) / 1000);
        const extra = made - Math.max(0, planServings);
        if (extra > best)
            best = extra;
    }
    return best;
}
/** The calendar day after `date` (YYYY-MM-DD), the default day for leftovers. */
export function nextDayIso(date) {
    const [y, m, d] = date.split('-').map(Number);
    const dt = new Date(Date.UTC(y, m - 1, d));
    dt.setUTCDate(dt.getUTCDate() + 1);
    return dt.toISOString().slice(0, 10);
}
//# sourceMappingURL=leftovers.js.map